import { PatchEvent, set, unset } from "part:@sanity/form-builder/patch-event";
import React, { useState } from "react";
import getVideoId from "get-video-id";
import { withDocument } from "part:@sanity/form-builder";
import { nanoid } from "nanoid";
import { TextInput, Stack, Button, Label, Badge, Spinner, Inline } from "@sanity/ui";
import { AddIcon } from "@sanity/icons";
import { number } from "prop-types";

const VideoIdFieldComponent = (props, ref) => {
    const { onChange, value } = props;

    const [newDoc, setNewDoc] = useState < {
        id: string;
        title: string;
        service: string;
        thumbnail: string;
        url: string;
        ratio: number;
    } > (value || null);

    const createPatchFrom = (value: any) =>
        PatchEvent.from(value === "" ? unset() : set(value));

    async function getThumbnail({ id, service }) {

        if (service === "vimeo") {
            const response = await fetch(
                `https://vimeo.com/api/oembed.json?url=https://player.vimeo.com/video/${id}`
            );
            const json = await response.json();
            const ratio = json.width && json.height ? parseFloat((json.width / json.height).toFixed(2)) : 0;
            return { thumbnail: json.thumbnail_url.split("_")[0] + "_320x180", ratio: ratio, title: json.title };
        }

        return null;
    }

    async function onUrlChange(e) {
        const url = e.target.value;

        if (url.trim().length) {
            const { id, service } = getVideoId(url);
            const {thumbnail, ratio, title} = await getThumbnail({ id, service });
            const doc = await setNewDoc({ url, id, title, service, thumbnail, ratio });
            // setTimeout(()=>{
            //     save();
            // },1000)
        } else {
            // setTimeout(()=>{
            //     save();
            // },1000)
        }
    }

    function save() {
        onChange(
            createPatchFrom({
                _key: nanoid(),
                _type: "object",
                _name: "videoId",
                ...newDoc,
            })
        );
    }

    return (
        <Stack space={3}>

            <Label>{props.type.title}</Label>
   
            <TextInput
                type="text"
                onChange={onUrlChange}
                ref={ref}
                value={newDoc?.url}
            />

            <Inline space={2}>
            {newDoc?.thumbnail && <img src={newDoc.thumbnail} style={{'border-radius':'5px', width: 200}} />}
            { newDoc?.thumbnail && newDoc?.id && <Badge tone="positive">Valid</Badge> }
            { newDoc?.thumbnail && newDoc?.id && <Badge tone="positive" mode="outline">{newDoc.id}</Badge> }
            { newDoc?.thumbnail && newDoc?.ratio && <Badge mode="outline">{newDoc.ratio}</Badge> }
            </Inline>

             <Button
                text={`Update`}
                fontSize={2}
                // icon={AddIcon}
                padding={3}
                tone="positive"
                onClick={save}
            /> 
        </Stack>
    );
};

export const VideoIdField = withDocument(
    React.forwardRef(VideoIdFieldComponent)
);


// WEBPACK FOOTER //
// ./src/VideoIdField.tsx